import React, { useEffect, useState } from "react";
import { Typography, Grid } from "@mui/material";
import { Stack } from "@mui/system";
import "./FillFeedback.scss";
import Rating from "@mui/material/Rating";
import ButtonModule from "../common/Button";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTS from "../../globals/common_utilities/constant";
import { API } from "../../globals/constants";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import InputField from "../common/InputField";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { isEmpty, FORM_VALIDATION } from "../../globals/constants";

function CreateFeedback() {
  const dispatch = useDispatch();
  const [questions, setQuestion] = useState([]);
  const [feedbackId, setFeedbackId] = useState("");

  const handleRating = (val, index) => {
    let data = [...questions];
    data[index].answer = val;
    setQuestion([...data]);
  };
  const handleTextAnswer = (e, index) => {
    let data = [...questions];
    data[index].answer = e.target.value;
    setQuestion([...data]);
  };
  const handleRadioChange = (item, index) => {
    let data = [...questions];
    data[index].answer = item;
    setQuestion([...data]);
  };
  const handleChangeCheckBox = (e, answer, index, i) => {
    let temp = [...questions];
    if (temp[index].hasOwnProperty("answer")) {
      if (temp[index]?.answer?.includes(e.target.value)) {
        temp[index].answer = temp[index].answer.filter(
          (checkedValue) => checkedValue !== e.target.value
        );
        setQuestion([...temp]);
      } else {
        let selectedValue = [];
        selectedValue = temp[index].answer;
        selectedValue.push(e.target.value);
        temp[index].answer = selectedValue;
        setQuestion([...temp]);
      }
    } else {
      temp[index].answer = [];
      temp[index].answer = [...temp[index].answer, e.target.value];
      setQuestion([...temp]);
    }
  };
  const renderOptions = (value, index) => {
    if (value.question_type === "star") {
      return (
        <Rating
          name="size-small"
          value={value.answer}
          onChange={(event, newValue) => {
            handleRating(newValue, index);
          }}
          max={5}
        />
      );
    } else if (value.question_type === "textbox") {
      return (
        <>
          <Grid conatiner>
            <InputField
              className="textbox_input"
              type="text"
              placeholder="Enter Answer In 250 Charcters"
              id="optionNameTest"
              maxlength={100}
              onChange={(e) => handleTextAnswer(e, index)}
            />
          </Grid>
        </>
      );
    } else if (value.question_type === "radio") {
      let data = JSON.parse(value.options);
      return (
        <>
          {data.map((item, i) => {
            return (
              <>
                <Stack className="set_option">
                  <Grid container>
                    <input
                      type="radio"
                      value={item}
                      name={item}
                      checked={item === value?.answer ? true : false}
                      onChange={() => handleRadioChange(item, index)}
                    />
                    <label className="containerLabel font-style-10 set_margin">
                      {item}
                    </label>
                  </Grid>
                </Stack>
              </>
            );
          })}
        </>
      );
    } else if (value.question_type === "checkbox") {
      let data = JSON.parse(value.options);
      return (
        <>
          {data.map((item, i) => {
            return (
              <>
                <Stack className="set_option">
                  <Grid container>
                    <input
                      type="checkbox"
                      value={item}
                      onChange={(e) =>
                        handleChangeCheckBox(e, value.answer, index, i)
                      }
                    />
                    <label className="containerLabel font-style-10 set_margin">
                      {item}
                    </label>
                  </Grid>
                </Stack>
              </>
            );
          })}
        </>
      );
    }
  };
  const isValid = () => {
    let data = [...questions];
    let error = false;
    let err_data = [];
    let data_check = data.forEach((item) => {
      if (item?.question_type === "textbox") {
        console.log(
          "FORM_VALIDATION.SCRIPT.test(item?.answer)",
          FORM_VALIDATION.SCRIPT.test(item?.answer)
        );
        if (!item?.answer) {
          console.log("conition 1-1");
          toast.error(`Please add answers`, {
            position: "bottom-right",
            toastId: "answer",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          let data = [...err_data];
          err_data.push(true);
          return (error = true);
        } else {
          if (FORM_VALIDATION.SCRIPT.test(item?.answer)) {
            return (error = false);
          } else {
            toast.error(`Please add valid answers`, {
              position: "bottom-right",
              toastId: "answer",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: { background: "#000", color: "#ffffff" },
            });
            let data = [...err_data];
            err_data.push(true);
            return (error = true);
          }
        }
      } else if (item?.question_type === "radio") {
        console.log("conition 2");
        if (item?.answer) {
          error = false;
        } else {
          toast.error(`Please select the options`, {
            position: "bottom-right",
            toastId: "answer",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          let data = [...err_data];
          err_data.push(true);
          error = true;
        }
      } else if (item?.question_type === "checkbox") {
        console.log("conition 3");
        if (item?.answer?.length > 0) {
          error = false;
        } else {
          toast.error(`Please select the options`, {
            position: "bottom-right",
            toastId: "answer",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          let data = [...err_data];
          err_data.push(true);
          return (error = true);
        }
      } else if (item?.question_type === "star") {
        console.log("condition 4", data);
        if (item?.answer) {
          return (error = false);
        } else {
          console.log("condition 4-2");
          toast.error(`Please select the ratings`, {
            position: "bottom-right",
            toastId: "answer",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          let data = [...err_data];
          err_data.push(true);
          return (error = true);
        }
      }
    });
    console.log("check the valid function bbbbbbbbbbbbbbbb", err_data);
    return err_data;
  };
  const submit = async () => {
    console.log("check the valid function",isValid().includes(true));
    if (!isValid().includes(true)) {
      console.log("check the valid function 00000000000000000", isValid());
        let data = [...questions];
        let error = false;
        data.forEach((item) => {
          if (item.hasOwnProperty("answer")) {
            if (item.answer === "" || item.answer.length === 0) {
              return (error = true);
            } else {
              return (error = false);
            }
          } else {
            return (error = true);
          }
        });
        let questionArray = data.map((value) => {
          if (value.question_type === "checkbox") {
            value = {
              question: value.question,
              option: JSON.stringify(value.answer),
              question_type: value.question_type,
              question_sequence: value.question_sequence,
              answer: "",
            };
          } else if (value.question_type === "radio") {
            value = {
              question: value.question,
              option: JSON.stringify(value.answer),
              question_type: value.question_type,
              question_sequence: value.question_sequence,
              answer: "",
            };
          } else if (value.question_type === "star") {
            value = {
              question: value.question,
              rating: value.answer,
              question_type: value.question_type,
              question_sequence: value.question_sequence,
              answer: "",
            };
          } else {
            value = {
              question: value.question,
              answer: value.answer,
              question_type: value.question_type,
              question_sequence: value.question_sequence,
              answer: value.answer,
            };
          }
          return value;
        });
        if (!error) {
          const bodyParam = {
            feedback_response: [...questionArray],
          };
          const search = window.location.search;
          const params = new URLSearchParams(window.location.search);
          const data = params.get("feedbackLink");
          let queryParam = {
            feedback_id: data,
          };
          const Response = await api_call(
            CONSTANTS.API_METHODS.POST,
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
              API.END_POINTS.SAVE_FEEDBACK,
            queryParam,
            {},
            bodyParam
          );
          if (Response.status === 200) {
            toast.success("Feedback submitted successfully", {
              position: "bottom-right",
              autoClose: 3000,
              toastId: "submitFeedback",
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              style: { background: "#000", color: "#ffffff" },
            });
          } else if (Response.status === 409) {
            toast.error("Feedback Already Submitted", {
              position: "bottom-right",
              autoClose: 3000,
              toastId: "submitFeedback",
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              style: { background: "#000", color: "#ffffff" },
            });
          }
        } else {
          toast.error(`Please answer all questions`, {
            position: "bottom-right",
            toastId: "answer",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      } else {
    }
  };
  const getFeedbackData = async (value) => {
    let queryParam = {
      feedback_id: value,
    };
    const response = await api_call(
      CONSTANTS.API_METHODS.GET,
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
        API.END_POINTS.GET_FEEDBACK_QUESTION,
      queryParam,
      {},
      {}
    );
    if (response.status == 200) {
      let data =
        response.data.data.questions.rows[0].feedback_template_questions;
      let temp = [];
      let temp_check = data.map((item) => {
        // let temp_data = []
        let temp_data = [...temp];
        let index = item.question_sequence;
        temp_data[index - 1] = item;
        temp = temp_data;
      });
      setQuestion([...temp]);
      console.log(
        " setFeedbackId(response.data.data.questions.rows[0].title);",
        response.data.data.title
      );
      setFeedbackId(response.data.data.title);
    }
  };
  useEffect(() => {
    const search = window.location.search.split("=")[1];
    getFeedbackData(search);
  }, []);

  return (
    <>
      <Stack className="create_feedback">
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography className="feedback">Feedback</Typography>
            <Typography className="feedback">
              Training Name - {feedbackId}
            </Typography>
          </Grid>
        </Grid>
        <Stack className="set_feedback">
          <Stack>
            {questions.map((item, index) => {
              return (
                <Stack className="template_details">
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography className="questions">
                        {item.question}
                      </Typography>
                    </Grid>
                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                      {renderOptions(item, index)}
                    </Grid>
                  </Grid>
                </Stack>
              );
            })}
          </Stack>
          <Stack direction="row">
            <ButtonModule
              role="primary"
              value="Save"
              onClick={() => submit()}
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}

export default CreateFeedback;
